<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''">
                {{ $t('app.choose_license') }}
            </h4>
            <div class="col-md-12 text-center" style="padding:0">
                <span 
                    v-if="licensesLoading"
                    class="spinner-grow spinner-grow-sm mr-1" 
                    role="status" 
                    aria-hidden="true">
                </span>
                <select 
                    v-if="!licensesLoading"
                    id="transactionType"
                    class="form-control" 
                    :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''"
                    v-model="row.license_id"
                    v-on:change="onInputChange">
                    <option 
                        v-for="(row, idx) in licenses" 
                        :key="idx"
                        :value="row.id">
                        {{ ($i18n.locale == 'ar') ? row.ar.title : row.en.title }}
                    </option>
                </select>
            </div>
        </div>
    </div>
        
</template>

<script>
import iziToast from 'izitoast';

export default {
    namme: 'CardLicense',
    props: [
        'license_id'
    ],
    data(){
        return {
            auth: {
                access_token: ''
            },
            row: {
                license_id: this.$props.license_id
            },
            licenses: [],
            licensesLoading: true,
        }
    },
    mounted() {},
    created() {
        if(localStorage.getItem('access_token')) {
            this.auth.access_token = localStorage.getItem('access_token');
        }

        this.fetchData();
    },
    methods: {
        onInputChange(){
            const data = {
                license_id: this.row.license_id
            }
            this.$emit('licesneChange', data);
        },

        fetchData() {
            this.companiesLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                'Authorization': `Bearer ` + this.auth.access_token,
            };
            const options = {
                url: window.baseURL+'/licenses',
                method: 'GET',
                data: {},
                params: {
                    status: 'active',
                    paginate: 1000
                }
            }
            this.axios(options)
            .then(res => {
                this.licensesLoading = false;
                this.licenses = res.data.data.rows;
            })
            .catch(err => {
                this.companiesLoading = false;
                iziToast.warning({
                    icon: 'bx bx-angry',
                    title: '',
                    message: (err.response) ? err.response.data.message : ''+err
                });
            })
        },
    }
}
</script>
